module.exports = __webpack_public_path__ + "img/highintegral.7b0d0a17.svg";